import React from 'react';
import { Alert, Card, Typography } from 'antd';
// Components
import EstateList from '../EstateList/EstateList';
// Types
import { OwnershipTransferResult } from 'helpers/teams/cbTeamOwnershipTransfer.types';
// Styles
import styles from './TransferResultSection.module.scss';

const { Title } = Typography;

type TransferResultSectionProps = {
  result: OwnershipTransferResult;
};

const TransferResultSection = ({
  result,
}: TransferResultSectionProps): JSX.Element => (
  <Card
    className={styles.resultSection}
    title="Transfer result"
    style={{ marginTop: 16 }}
  >
    <Alert
      type="success"
      showIcon
      message="Transfer complete"
      description="Everything was transferred successfully. Chat access may finish updating in the background shortly — no further action is needed."
    />

    <Title level={5} style={{ marginTop: 16 }}>
      Moved
    </Title>
    <EstateList estate={result.moved} />
  </Card>
);

export default TransferResultSection;
